import type { Contract } from "../types/contract";

const baseContracts = [
  { id: "1", title: "Service Agreement - Acme Corporation", type: "Service Agreement", date: "Jan 15, 2024", status: "Approved" },
  { id: "2", title: "Employment Agreement - John Smith", type: "Employment Agreement", date: "Feb 03, 2024", status: "Approved" },
  { id: "3", title: "Non-Disclosure Agreement - Innovate Partners", type: "NDA", date: "Mar 10, 2024", status: "Approved" },
  { id: "4", title: "Software License Agreement - TechVista Inc", type: "Software License", date: "Apr 22, 2024", status: "Pending Review" },
  { id: "5", title: "Consulting Services Contract - GlobalTech LLC", type: "Consulting", date: "May 05, 2024", status: "Draft" },
  { id: "6", title: "Master Service Agreement - DataCorp", type: "MSA", date: "Jun 12, 2024", status: "Pending Review" },
  { id: "7", title: "Partnership Agreement - Joint Venture Co", type: "Partnership", date: "Jul 08, 2024", status: "Draft" },
  { id: "8", title: "Supply Agreement - Manufacturing Inc", type: "Supply", date: "Aug 15, 2024", status: "Approved" },
  { id: "9", title: "License Agreement - Media Holdings", type: "License", date: "Sep 01, 2024", status: "Pending Review" },
  { id: "10", title: "Lease Agreement - Office Space Ltd", type: "Lease", date: "Oct 20, 2024", status: "Approved" },
  { id: "11", title: "Insurance Policy - Risk Management Co", type: "Insurance", date: "Nov 05, 2024", status: "Draft" },
  { id: "12", title: "Vendor Agreement - Logistics Partners", type: "Vendor", date: "Dec 01, 2024", status: "Pending Review" },
  { id: "13", title: "Subscription Agreement - SaaS Platform", type: "Subscription", date: "Jan 10, 2025", status: "Approved" },
  { id: "14", title: "Agency Agreement - Marketing Pro", type: "Agency", date: "Feb 14, 2025", status: "Draft" },
  { id: "15", title: "Franchise Agreement - Retail Brand", type: "Franchise", date: "Mar 01, 2025", status: "Pending Review" }
] as const;

export const mockContracts: Contract[] = baseContracts.map((item) => ({
  id: item.id,
  title: item.title,
  type: item.type,
  date: item.date,
  status: item.status,
  documentRef: null
}));
